import { flushSync } from "react-dom"
import { islandMotionCssVariables } from "./islandMotion.utils"

export const WILSON_BAR_TRANSITION =
    "wilson-bar-morph [view-transition-name:wilson-bar]"

const GROWING_CLASS = "wilson-bar-growing"

function canMorph(): boolean {
    if (typeof document === "undefined") return false
    if (typeof document.startViewTransition !== "function") return false
    return !window.matchMedia?.("(prefers-reduced-motion: reduce)").matches
}

export function isWilsonBarMorphing(): boolean {
    return (
        typeof document !== "undefined" &&
        document.documentElement.classList.contains(GROWING_CLASS)
    )
}

export function growIslandIntoPalette(update: () => void) {
    if (!canMorph()) {
        update()
        return
    }
    const root = document.documentElement
    for (const [name, value] of Object.entries(islandMotionCssVariables())) {
        root.style.setProperty(name, value)
    }
    root.classList.add(GROWING_CLASS)
    const transition = document.startViewTransition(() => flushSync(update))
    transition.ready.catch(() => {
        // A skipped morph still applies the update; there is just no animation.
    })
    void transition.finished.finally(() => root.classList.remove(GROWING_CLASS))
}
